<script>
    import { confirmBudget, getOrderData, onErrorImg } from "../services/orders";
    import { _, translate, langs } from "../services/i18n";
    import { alert } from "../services/stores/alert";
    import { loading } from "../services/stores/loading";
    import { getModelDicc } from "../services/dicc";
    import ViewerButton from "../components/ViewerButton.svelte";
    import ARButton from "../components/ARButton.svelte";
    import Accordion from "../components/Accordion.svelte";
    import { loadLibraryDictionary, libTranslate } from "../services/libraryDictionary";
    import { getModelData } from "../services/models";
    import { decodeOrderId } from "../../../common/orders";
    import { ImageTypes, getImage } from "../services/vendors";
    import { getImageUrl } from "../services/images";

    export let params;
    export let orderHash = params.orderId;

    const orderId = decodeOrderId(orderHash);

    // Se carga en loadDatas()
    let materials, models, dicc, accessories, customReportLogo = null;

    /** @type {Object<string,Promise<Object<string,string>>>}*/
    let artInfo = {};
    /**
     *
     * @param {string} article
     * @return {promise<Object<string,string>>}
     */
    function getAccNames(article) {
        if (!artInfo[article]) {
            // TODO: Esta llamada solo funciona con elementos que estén en el catálogo 3D
            // y habría que eliminar (el código comentado) cuando se terminen las pruebas de
            // la versión 4.1
            //artInfo[article] = new Promise((res, err) => {
            //    fetch(`/catalog/model/${article}`)
            //        .then((response) => response.json())
            //        .then((artInfo) => {
            //            const accNames = artInfo.metadata?.accessories?.reduce(
            //                (acc, { identifier, name }) => {
            //                    acc[identifier] = name;
            //                    return acc;
            //                },
            //                {}
            //            );
            //            res(accNames);
            //        });
            //});
            artInfo[article] = new Promise((res,err) => {
                fetch(`/api/v1/model/${article}/accessories`)
                    .then(response => response.json())
                    .then(artInfo => {
                        const accNames = artInfo.accessories?.reduce(
                            (acc, { id, name }) => {
                                acc[id] = name;
                                return acc;
                            },
                            {}
                        );
                        res(accNames);
                    })
            })
        }
        return artInfo[article];
    }

    function accessoryTitle(article, accType, accIdentifier) {}

    async function getModels(clientId) {
        let allModels = await (
            await fetch(`/catalog/models?clientId=${clientId}`)
        ).json();

        let nodeChildrens = allModels.root;
        let repeat = false;
        do {
            repeat = false;
            nodeChildrens = nodeChildrens.flatMap((n) => {
                if (n.children && n.children.length > 0) {
                    repeat = true;
                    return n.children;
                } else return n;
            });
        } while (repeat);
        return nodeChildrens;
    }

    async function getMaterials(clientId) {
        return await (
            await fetch(`/catalog/materials?clientId=${clientId}`)
        ).json();
    }

    async function getAccessories(clientId) {
        return await (
            await fetch(`/catalog/accessories?clientId=${clientId}`)
        ).json();
    }

    const g_modelNames = {};
    const preloadModelName = async identifier => {   
        if (!g_modelNames[identifier]) {
            const modelData = await getModelData(identifier);
            g_modelNames[identifier] = modelData?.data?.model;
        }
    }

    const getModelName = (identifier) => {
        if (!g_modelNames[identifier]) return "";
        return libTranslate(g_modelNames[identifier], g_modelNames[identifier]);
    }


    const loadDatas = async () => {
        if (orderId === undefined || orderId === null) {
            alert.newAlert({
                message: "Error, no hay un id de pedido definido",
                type: "error",
            });
            return;
        }
        const orderData = await getOrderData({ orderId });

        await loadLibraryDictionary();
        const promises = await Promise.all([
            getMaterials(orderData.client),
            getModels(orderData.client),
            getModelDicc(orderData.client),
            getAccessories(orderData.client),
            getImage(orderData.client, ImageTypes.REPORT_LOGO)
        ]);

        // Preload articles info

        const preloadPromises = [];
        orderData.data.forEach((art) => {
            preloadPromises.push(getAccNames(art.identifier));
            preloadPromises.push(preloadModelName(art.identifier));
        });

        await Promise.allSettled(preloadPromises);

        materials = promises[0];
        models = promises[1];
        dicc = promises[2];
        accessories = promises[3];
        customReportLogo = promises[4];
        if (customReportLogo) {
            console.log(customReportLogo);
            customReportLogo = getImageUrl({ id: customReportLogo.imageId });
            console.log(customReportLogo);
        }

        dicc.findArt = (art) =>
            dicc.find((d) => d.article === art)?.description ?? art;
        return orderData;
    };

    const printAccesory = ({ model: article, accessory: { index, id } }) => ({
        type: article.metadata.accessories.find((a) => a.typeId === index)
            .typeName,
        name: article.metadata.accessories.find((a) => a.identifier === id)
            .name,
    });

    const isTelas = (model) => Object.keys(model.lineReport).length > 1;
    const isDBOrder = orderData => orderData.every(item => item.sceneIndex === -1);

    const printModelMaterials = (model) =>
        Object.keys(model.lineReport)
            .filter((lr) => lr !== "accessories")
            .map(
                (e) =>
                    `<span class="material">${dicc.findArt(e)}</span> ${
                        model.lineReport[e]
                    }`
            )
            .join("<br>");

    import { oswald } from "../services/oswald";
    import { onDestroy, onMount } from "svelte";
    import { applyColorScheme } from "../services/colorScheme";
    let mainElement;
    const print2PDF = () => {
        loading.newLoading();
        new Promise((resolve) => {
            const pdf = new window.jspdf.jsPDF({
                unit: "px",
                hotfixes: ["px_scaling"],
            });

            pdf.addFileToVFS("Oswald.ttf", oswald);
            pdf.addFont("Oswald.ttf", "Oswald", "normal");

            pdf.html(mainElement, {
                callback: () => {
                    resolve(), pdf.output("save", "order.pdf");
                },
                margin: [30, 0, 30, 0],
            });
        }).then(() => loading.removeLoading());
    };

    function haveDBItems(order) {
        return order.data.some(item => item.sceneIndex === -1)
    }

    function mustShowScene(order, sceneIndex) {
        // Si la última escena del pedido solo contiene elementos sin 3D, entonces estará vacía. Con esto impedimos que se muestre
        return !order.emptyMainScene || sceneIndex < order.images.length - 1 ;
    }

    function priceWarning(item) {
        return item.price.discountConditions.every(c => c === 0) &&
               item.price.finalPrice === 0;
    }

    onMount(() => {
        applyColorScheme("reports");
    });
</script>

{#await loadDatas() then order}
    <!-- Ocultado el botón de imprimir a pdf ya que el plugin no funciona bien
  <button on:click={print2PDF} class="btn-3d third pdf-button">
    Descargar PDF
  </button>
  -->
    <nav class="options-menu">
        <section>
            <span>{$_("nav_user_language")}:</span>
            {#each langs as lang}
                <button on:click={() => lang.action()}>{lang.name}</button>
            {/each}
        </section>
        <button onclick="window.print();"  class="btn-3d third print-button"><img src="/icons/printer.svg" class="print-icon" alt="print">{$_("report_print")}</button>
    </nav>
    <main bind:this={mainElement} style="padding: 0 15px;">
        {#if order.type !== "order" && order.type !== "budget"}
            <div class="error-not-found">
                {$_("alerts_errors_notLoadOrder404")}
            </div>
        {:else}
           
            <header>
                <ul style="">
                    {#if customReportLogo}
                        <img
                            src={customReportLogo}
                            alt="logo"
                            class="imgLogo"
                        />
                    {:else}
                        <img
                            src="/icons/default_logo_2.png"
                            alt="logo"
                            class="imgLogo"
                        />
                    {/if}
                    <h1 class="headerOrder">
                        {#if order.type === 'order'}
                            {$_("report_type_order")}
                        {:else if order.type === 'budget' && order.confirmationState === 0}                        
                            {$_("report_type_budget")}
                        {:else}                        
                            {$_("report_type_confirmed")}
                        {/if}
                    </h1>
                    <div class="orderNumberDate">
                        <span>{order.orderNumber}:S3D</span>
                        <span
                            >{new Date(
                                order.contactData.date
                            ).toLocaleDateString()}</span
                        >
                    </div>
                </ul>
            </header>
            <section class="header-data">
                <ul>
                    <li class="one">
                        {$_("report_headerData_name")}:
                        <span>
                            {order.contactData.clientName ? order.contactData.clientName : ""} 
                            {order.contactData.clientSurname1 ? order.contactData.clientSurname1 : ""} 
                            {order.contactData.clientSurname2 ? order.contactData.clientSurname2 : ""}
                        </span>
                    </li>
                    <li>
                        {$_("report_headerData_reference")}:
                        <span>{order.contactData.reference}</span>
                    </li>
                    <li>
                        {$_("report_headerData_cif")}:
                        <span>{order.contactData.cif}</span>
                    </li>
                    <li>
                        {$_("report_headerData_address")}:
                        <span>{order.contactData.address}</span>
                    </li>
                    <li>
                        {$_("report_headerData_phone")}:
                        <span>{order.contactData.phone1}</span>
                    </li>
                    <li>
                        {$_("report_headerData_shop")}:
                        <span>{order.shopName}</span>
                    </li>
                    <li>
                        {$_("report_headerData_city")}:
                        <span>{order.contactData.city}</span>
                    </li>
                    <li>
                        {$_("report_headerData_email")}:
                        <span>{order.contactData.email}</span>
                    </li>
                    <li>
                        {$_("report_headerData_zipCode")}:
                        <span>{order.contactData.zipCode}</span>
                    </li>
                </ul>
            </section>

            <!-- Escenas: solamente se muestra si no es un pedido exclusivo de BBDD -->
            {#if !isDBOrder(order.data)}
                <section class="scene-data">
                    {#each order.images as sceneImage, indexScene}
                        <!-- Si la última escena del pedido solo contiene elementos sin 3D, entonces estará vacía. Con esto impedimos que se muestre -->
                        {#if mustShowScene(order, indexScene)}
                            <article>
                                <section class="header-scene">
                                    {#if order.images.length !== 1}
                                        <header>
                                            <h1>
                                                {$_("report_scene_title")}
                                                {indexScene + 1}
                                            </h1>
                                        </header>
                                    {/if}
                                    <figure>
                                        <ViewerButton
                                            sceneId={indexScene}
                                            {orderId}
                                            styleVariant="medium"
                                            align="right"
                                        />
                                        <ARButton
                                            sceneId={indexScene}
                                            {orderId}
                                            styleVariant="medium"
                                            align="right"
                                        />
                                        <img
                                            src={sceneImage}
                                            alt={"scene-" + indexScene}
                                            class="scene-image"
                                        />
                                        <div class="material-message">
                                            {$_("report_materials_message")}
                                        </div>
                                    </figure>
                                </section>
                                {#if [...new Set(order.shortFabricReport
                                            .filter((r) => r.sceneIndex === indexScene)
                                            .map((r) => r.fabricId))].length > 0}
                                    <section class="header-materials">
                                        <header>
                                            {$_("report_materials_title")}
                                        </header>
                                        <body class="materials">
                                            {#each [...new Set(order.shortFabricReport
                                                        .filter((r) => r.sceneIndex === indexScene)
                                                        .map((r) => r.fabricId))] as fabricId}
                                                <ul>
                                                    <li class="material-item">
                                                        <p>{dicc.findArt(fabricId)}</p>
                                                        <img
                                                            src={"/library/materials/" +
                                                                materials.root.find(
                                                                    (m) =>
                                                                        m.id ===
                                                                        fabricId
                                                                )?.icon}
                                                            on:error={onErrorImg(
                                                                "material"
                                                            )}
                                                            alt="materialImg"
                                                        />
                                                    </li>
                                                </ul>
                                            {/each}
                                        </body>
                                    </section>
                                {/if}
                                <section class="header-articles">
                                    <header>
                                        {$_("report_article_title")}
                                    </header>
                                    <body>
                                        {#each order.data.filter((r) => r.sceneIndex === indexScene) as article}
                                            <section
                                                class="item-box"
                                                class:special-item={article
                                                    .shoppingCartData.special}
                                            >
                                                {#if article.shoppingCartData.special}
                                                    <div class="special-item">
                                                        <span
                                                            >{$_(
                                                                "report_article_special"
                                                            )}</span
                                                        >
                                                    </div>
                                                {/if}
                                                <span class="articles-title">
                                                    <p>{getModelName(article.metadata.modelName)}</p>

                                                    <p>
                                                        {dicc.findArt(
                                                            article.identifier
                                                        )}
                                                    </p>
                                                </span>
                                                <ul>
                                                    <li>
                                                        <img
                                                            src={"/library/models/" +
                                                                models.find(
                                                                    (m) =>
                                                                        m.id ===
                                                                        article.identifier
                                                                )?.icon}
                                                            on:error={onErrorImg(
                                                                "model"
                                                            )}
                                                            alt="modelImg"
                                                        />
                                                    </li>
                                                    <li class="articles-data">
                                                        {#if isTelas(article)}
                                                            <p>
                                                                {$_(
                                                                    "report_article_materials"
                                                                )}:<br />
                                                                <span
                                                                    >{@html printModelMaterials(
                                                                        article
                                                                    )}</span
                                                                >
                                                            </p>
                                                        {/if}

                                                        <p>
                                                            {$_(
                                                                "report_article_measures"
                                                            )}:
                                                            <span
                                                                >{`${$_(
                                                                    "report_article_width"
                                                                )}: ${
                                                                    article.size.w
                                                                } | ${$_(
                                                                    "report_article_height"
                                                                )}: ${
                                                                    article.size.h
                                                                } | ${$_(
                                                                    "report_article_depth"
                                                                )}: ${
                                                                    article.size.d
                                                                }`}</span
                                                            >
                                                        </p>

                                                        {#if article.shoppingCartData.remarks}
                                                            <p>
                                                                {$_(
                                                                    "report_article_notes"
                                                                )}:
                                                                <span
                                                                    >{article
                                                                        .shoppingCartData
                                                                        .remarks}</span
                                                                >
                                                            </p>
                                                        {/if}
                                                    </li>
                                                    <li class="articles-data">
                                                        <p>
                                                            {$_(
                                                                "report_article_unities"
                                                            )}:
                                                            <span
                                                                >{article.price
                                                                    .quantity}</span
                                                            >
                                                        </p>
                                                        <p>
                                                            {$_(
                                                                "report_article_basePrice"
                                                            )}:
                                                            <span>{@html order.formatLineUnitPrice(article)}</span>
                                                        </p>
                                                        <p>
                                                            {$_(
                                                                "report_article_total"
                                                            )}:
                                                            <span>{@html order.formatLineTotalPrice(article)}</span>
                                                            {#if priceWarning(article)}
                                                                <p class="price-warning">
                                                                    {$_("alerts_info_priceWarning")}
                                                                </p>
                                                            {/if}
                                                        </p>
                                                    </li>
                                                </ul>
                                                <ul class="accessories-items">
                                                    {#each Object.keys(article.accessories) as acc}
                                                        <li class="accessory-item">
                                                            {#await getAccNames(article.identifier)}
                                                                <p />
                                                            {:then artAccs}
                                                                <img
                                                                    src={"/library/accessories/" +
                                                                        (accessories.root.find(
                                                                            (m) =>
                                                                                m.id ===
                                                                                article
                                                                                    .accessories[
                                                                                    acc
                                                                                ]
                                                                        )?.icon ?? acc)}
                                                                    on:error={onErrorImg(
                                                                        "accessory"
                                                                    )}
                                                                    alt="Accessory IMG"
                                                                />
                                                                <p
                                                                    title={acc +
                                                                        " - " +
                                                                        artAccs[
                                                                            article
                                                                                .accessories[
                                                                                acc
                                                                            ]
                                                                        ]}
                                                                >
                                                                    {acc +
                                                                        " - " +
                                                                        artAccs[
                                                                            article
                                                                                .accessories[
                                                                                acc
                                                                            ]
                                                                        ]}
                                                                </p>
                                                            {/await}
                                                            <!-- <img src={'/library/accessories/' + (accessories.root.find(m => m.id === article.accessories[acc])?.icon ?? acc)} on:error={onErrorImg('accessory')} alt="Accessory IMG"/> -->
                                                        </li>
                                                    {/each}
                                                </ul>
                                            </section>
                                        {/each}
                                    </body>
                                </section>
                                {#if order.images.length !== 1}
                                    <footer>
                                        <p>{$_("report_scene_total")}</p>
                                        <div class="spikes">
                                            <div class="spike" />
                                            <div class="spike" />
                                            <div class="spike" />
                                            <div class="spike" />
                                        </div>
                                        <p class="price-box-scene">
                                            {$_("report_totalPrice")}: {@html order.formatPrice(
                                                order.getScenePrice(indexScene), 
                                                null,
                                                false
                                            )}
                                        </p>
                                    </footer>
                                {/if}
                            </article>
                        {/if}
                    {/each}
                </section>
            {/if}

            <!-- Elementos sin representación 3D -->
            {#if haveDBItems(order)}
            <section class="scene-data">
                <article>
                    <section class="header-scene">
                        <header>
                            <h1>
                                {$_("report_scene_dbElements")}
                            </h1>
                        </header>
                    </section>
                    <!-- TODO: Probar esto con elementos de BBDD -->
                    {#if [...new Set(order.shortFabricReport
                                .filter((r) => r.sceneIndex === -1)
                                .map((r) => r.fabricId))].length > 0}
                        <section class="header-materials">
                            <header>
                                {$_("report_materials_title")}
                            </header>
                            <body class="materials">
                                {#each [...new Set(order.shortFabricReport
                                            .filter((r) => r.sceneIndex === -1)
                                            .map((r) => r.fabricId))] as fabricId}
                                    <ul>
                                        <li class="material-item">
                                            <p>{dicc.findArt(fabricId)}</p>
                                            <img
                                                src={"/library/materials/" +
                                                    materials.root.find(
                                                        (m) =>
                                                            m.id ===
                                                            fabricId
                                                    )?.icon}
                                                on:error={onErrorImg(
                                                    "material"
                                                )}
                                                alt="materialImg"
                                            />
                                        </li>
                                    </ul>
                                {/each}
                            </body>
                        </section>
                    {/if}
                    <section class="header-articles">
                        <header>
                            {$_("report_article_title")}
                        </header>
                        <body>
                            {#each order.data.filter((r) => r.sceneIndex === -1) as article}
                                <section
                                    class="item-box"
                                    class:special-item={article
                                        .shoppingCartData.special}
                                >
                                    {#if article.shoppingCartData.special}
                                        <div class="special-item">
                                            <span
                                                >{$_(
                                                    "report_article_special"
                                                )}</span
                                            >
                                        </div>
                                    {/if}
                                    <span class="articles-title">
                                        <p>{getModelName(article.identifier)}</p>

                                        <p>
                                            {dicc.findArt(
                                                article.identifier
                                            )}
                                        </p>
                                    </span>
                                    <ul>
                                        <li>
                                            <img
                                                src={"/library/models/" +
                                                    models.find(
                                                        (m) =>
                                                            m.id ===
                                                            article.identifier
                                                    )?.icon}
                                                on:error={onErrorImg(
                                                    "model"
                                                )}
                                                alt="modelImg"
                                            />
                                        </li>
                                        <li class="articles-data">
                                            {#if isTelas(article)}
                                                <p>
                                                    {$_(
                                                        "report_article_materials"
                                                    )}:<br />
                                                    <span
                                                        >{@html printModelMaterials(
                                                            article
                                                        )}</span
                                                    >
                                                </p>
                                            {/if}

                                            <!-- TODO: Es posible incluir medidas en los artículos sin representación 3D? -->
                                            <p>
                                                <!--
                                                {$_(
                                                    "report_article_measures"
                                                )}:
                                                <span
                                                    >{`${$_(
                                                        "report_article_width"
                                                    )}: ${
                                                        article.size.w
                                                    } | ${$_(
                                                        "report_article_height"
                                                    )}: ${
                                                        article.size.h
                                                    } | ${$_(
                                                        "report_article_depth"
                                                    )}: ${
                                                        article.size.d
                                                    }`}</span
                                                >
                                                -->
                                            </p>

                                            {#if article.shoppingCartData.remarks}
                                                <p>
                                                    {$_(
                                                        "report_article_notes"
                                                    )}:
                                                    <span
                                                        >{article
                                                            .shoppingCartData
                                                            .remarks}</span
                                                    >
                                                </p>
                                            {/if}
                                        </li>
                                        <li class="articles-data">
                                            <p>
                                                {$_(
                                                    "report_article_unities"
                                                )}:
                                                <span
                                                    >{article.price
                                                        .quantity}</span
                                                >
                                            </p>
                                            <p>
                                                {$_(
                                                    "report_article_basePrice"
                                                )}:
                                                <!-- <span>{@html order.formatPrice(article.price.finalUnitPrice)}</span> -->
                                                <span>{@html order.formatLineUnitPrice(article)}</span>
                                            </p>
                                            <p>
                                                {$_(
                                                    "report_article_total"
                                                )}:
                                                <!-- <span>{@html order.formatPrice(article.price.finalUnitPrice * article.price.quantity)}</span> -->
                                                <span>{@html order.formatLineTotalPrice(article)}</span>

                                                {#if priceWarning(article)}
                                                    <p class="price-warning">
                                                        {$_("alerts_info_priceWarning")}
                                                    </p>
                                                {/if}
                                            </p>
                                        </li>
                                    </ul>
                                    <ul class="accessories-items">
                                        {#each Object.keys(article.accessories) as acc}
                                            <li class="accessory-item">
                                                {#await getAccNames(article.identifier)}
                                                    <p />
                                                {:then artAccs}
                                                    <img
                                                        src={"/library/accessories/" +
                                                            (accessories.root.find(
                                                                (m) =>
                                                                    m.id ===
                                                                    article
                                                                        .accessories[
                                                                        acc
                                                                    ]
                                                            )?.icon ?? acc)}
                                                        on:error={onErrorImg(
                                                            "accessory"
                                                        )}
                                                        alt="Accessory IMG"
                                                    />
                                                    <p
                                                        title={acc +
                                                            " - " +
                                                            artAccs[
                                                                article
                                                                    .accessories[
                                                                    acc
                                                                ]
                                                            ]}
                                                    >
                                                        {acc +
                                                            " - " +
                                                            artAccs[
                                                                article
                                                                    .accessories[
                                                                    acc
                                                                ]
                                                            ]}
                                                    </p>
                                                {/await}
                                                <!-- <img src={'/library/accessories/' + (accessories.root.find(m => m.id === article.accessories[acc])?.icon ?? acc)} on:error={onErrorImg('accessory')} alt="Accessory IMG"/> -->
                                            </li>
                                        {/each}
                                    </ul>
                                </section>
                            {/each}
                        </body>
                    </section>
                    {#if order.images.length !== 1}
                        <footer>
                            <p>{$_("report_scene_total")}</p>
                            <div class="spikes">
                                <div class="spike" />
                                <div class="spike" />
                                <div class="spike" />
                                <div class="spike" />
                            </div>
                            <p class="price-box-scene">
                                {$_("report_totalPrice")}: {@html order.formatPrice(
                                    order.getScenePrice(-1),
                                    null,
                                    false
                                )}
                            </p>
                        </footer>
                    {/if}
                </article>
            </section>
            {/if}

            {#if order.contactData.remarks}
                <section class="remark">
                    <header>{$_("report_remarks_observations")}</header>
                    <p>{order.contactData.remarks}</p>
                </section>
            {/if}

            {#if order.contactData.factoryRemarks}
                <section class="remark">
                    <header>{$_("report_remarks_fabric")}</header>
                    <p>{order.contactData.factoryRemarks}</p>
                </section>
            {/if}

            <section class="total-price" style="color: var(--theme-color-4);">
                <p>{$_("report_thanks")}</p>
                <div class="spikes">
                    <div class="spike" />
                    <div class="spike" />
                    <div class="spike" />
                    <div class="spike" />
                    <div class="spike" />
                    <div class="spike" />
                    <div class="spike" />
                    <div class="spike" />
                    <div class="spike" />
                </div>
                <p id="price">
                    {$_("report_totalPrice")}: {@html order.formatPrice(
                        order.getTotalPrice,
                        null,
                        false
                    )}
                </p>
            </section>
        {/if}
        {#if order.anonymousMode}
            <p>{$_("report_anonymousModeMessage")}</p>
        {/if}
    </main>
{:catch error}
    <div class="error-not-found">{$_("alerts_errors_notLoadOrder404")}</div>
{/await}

<svelte:head>
    <link rel="stylesheet" href="/styles/pages/orderReport.css" />
</svelte:head>

<style>
    .error-not-found {
        margin-top: 24px;
        text-align: center;
        font-size: 32px;
        color: var(--theme-color-4);
    }

    main {
        max-width: 210mm;
        margin: 0 auto;
        letter-spacing: 1.5px;
        font-weight: 400;
    }

    .price-warning {
        text-transform: none;
        color: #ca590d;
        font-size: 1.1em;
        padding-top: 18px;
    }
    /*  .pdf-button {
    position: fixed;
    top: 20px;
    right: 20px;
   }
   */
   .options-menu {
        border: 1px;
        margin: 10px;
        /*border-color: var(--theme-color-4);*/
        border-color: lightgray;
        border-style: solid;
        padding: 10px;
        border-radius: 2px;
        width: fit-content;
        position: relative;
        float: left;
        display: flex;
        gap: 5px;;
        flex-direction: column;
   }

   .options-menu section {
        display: flex;
        gap: 5px;
        flex-direction: row;
        align-items: baseline;
   }

   .print-icon {
        height: 2em
   }

   .print-button {
    padding-left: 5px;
   }

    @media (max-width: 768px) {
        main {
            margin: 0 !important;
        }
        .options-menu {
            display:none
        }
    }

    @media (max-width: 1025px) {
        .options-menu {
            display:none
        }
    }

</style>
